import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import theme from "styles/theme"
import { StyledP, StyledLeft, StyledRight } from "./cards.style"
import CardWrapper from "./CardWrapper"
import CardButton from "./CardButton"

const ThirtyYearsCard = props => {
  const { data } = useStaticQuery(query)
  const { thirtyYearsCard } = data
  const { location } = props
  return (
    <CardWrapper
      width="343px"
      height="300px"
      bgColor={theme.colors.primary.gray}
    >
      <StyledLeft>
        <StyledP>{thirtyYearsCard.leadText}</StyledP>
        <StaticImage
          src="../../images/logo30.svg"
          alt="食物繊維と向き合って30年"
          placeholder="none"
        />
        <CardButton
          link="/thirty-years/"
          sdColor={theme.colors.shadow.gray}
          location={location}
        />
      </StyledLeft>
      <StyledRight>
        <StaticImage
          src="../../images/logo-francois.svg"
          alt="フランソア"
          placeholder="none"
        />
        <StaticImage
          src="../../images/logo-soygood.svg"
          alt="SOYGOOD｜フランソア"
          placeholder="none"
        />
      </StyledRight>
    </CardWrapper>
  )
}

const query = graphql`
  {
    data: componentsYaml {
      thirtyYearsCard {
        leadText
      }
    }
  }
`

export default ThirtyYearsCard
